// extracted by mini-css-extract-plugin
export var label = "VolunteerVacancySearch-module--label--c7ec8";
export var noresults = "VolunteerVacancySearch-module--noresults--2cf77";
export var searchcontainer = "VolunteerVacancySearch-module--searchcontainer--39f9f";
export var searchinput = "VolunteerVacancySearch-module--searchinput--39683";
export var title = "VolunteerVacancySearch-module--title--93022";
export var vacancies = "VolunteerVacancySearch-module--vacancies--c7ef7";